import CreateGroupForm from './CreateGroupForm'
import enhance from './CreateGroupForm.enhancer.js'

export default enhance(CreateGroupForm)



// WEBPACK FOOTER //
// ./src/components/organisms/CreateGroupForm/index.js